import React, { useMemo } from 'react';

import { Link, type LinkProps } from 'react-router-dom';

import { ReactComponent as LoadingIcon } from '@pkg/assets/icons/v2/loading-bars.svg';

import { type BaseDepButtonProps } from './DepButton';
import './DepButton.scss';

export type DepLinkButtonProps = BaseDepButtonProps & LinkProps;

export function DepLinkButton(props: DepLinkButtonProps) {
    const classNames = useMemo(() => {
        let classNames = 'yat-button';
        if (props.variant) classNames += ` yat-button--${props.variant}`;
        if (props.size) classNames += ` yat-button--${props.size}`;
        if (props.disabled || props.loading) classNames += ` yat-button--disabled`;
        if (props.glow) classNames += ` yat-button--glow`;
        if (props.display) classNames += ` yat-button--${props.display}`;
        if (props.classes) classNames += ` ${props.classes}`;

        return classNames;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.variant, props.size, props.disabled, props.loading, props.glow, props.display, props.classes]);
    const linkChildren = props.loading ? (
        <span className="yat-button__loader" aria-label="Loading">
            <LoadingIcon aria-hidden="true" />
        </span>
    ) : (
        <span className="yat-button__content">{props.children}</span>
    );

    return (
        <Link state={props.state} to={props.to} className={classNames} target={props.target}>
            {linkChildren}
        </Link>
    );
}
